import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom'
import QueryString from 'query-string'
import get from 'lodash.get'

const QueryParams = ({children, location, history}) => {
  const queryParams = () => QueryString.parse(location.search)

  const getQueryParam = (key, defaultValue) => {
    return get(queryParams(), key, defaultValue)
  }

  const setQueryParams = (params) => {
    const to = history.createHref({
      pathname: location.pathname,
      search: QueryString.stringify({
        ...queryParams(),
        ...params,
      })
    })

    history.push(to)
  }

  return children({
    queryParams: queryParams(),
    getQueryParam,
    setQueryParams,
  })
}

QueryParams.propTypes = {
  children: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default withRouter(QueryParams)
